<template>
  <!-- 整体画像 -->
  <div class="page">
    <div ref="scrollPage" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <!-- <el-row :gutter="12" class="firstFloor" id="first">
        <el-col :span="8">
          <div class="grid-content record">
            <div class="dataSources">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span style="margin-right:20px;">参建学校分布</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'schoolsChart'" :datas='schools.dataList' :colorName="'1'" :innerText="'数量'"></circularChart>
              </div>
            </div>

            <div class="picture">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span>其他参建单位数量(仅统计公司和协会)</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'countedChart'" :datas='counted.dataList' :colorName="'1'" :innerText="'数量'"></circularChart>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参建单位覆盖区域</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="width:100%;height:730px;">
                <distributionChart :refId="'unitsChart'" :datas='units.dataList'></distributionChart>
              </div>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第一层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户类型分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'userTypeChart'"
                :datas="userType.dataList"
                :colorName="'1'"
                :innerText="'总数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位类型分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'participatingUnitsChart'"
                :datas="participatingUnits.dataList"
                :transverseData="participatingUnits.transverseData"
                :colorList="participatingUnits.colorList"
                :legendList="participatingUnits.legendList"
                :innerText="'单位：所/家'"
              ></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-content">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span>建设单位师生实名注册情况</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <vcolumnarChart
                  :refId="'realNameChart'"
                  :datas="realName.dataList"
                  :transverseData="realName.transverseData"
                  :colorList="realName.colorList"
                  :legendList="realName.legendList"
                  :innerText="'单位：人'"
                ></vcolumnarChart>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位中主持院校实名教师占比情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="hostInstitutions.dataList"
                :colorList="hostInstitutions.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位中主持院校实名学生占比情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="takeCharge.dataList"
                :colorList="takeCharge.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位中参建院校实名学生占比情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="educational.dataList"
                :colorList="educational.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位实名教师无活动占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="proportionTeachers.dataList"
                :colorList="proportionTeachers.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>建设单位实名学生无活动占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="proportionStudents.dataList"
                :colorList="proportionStudents.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-content">
              <div class="generalBg_Virtualization"></div>
              <div class="header">
                <div class="header_Virtualization"></div>
                <div class="header_title">
                  <i class="h_icon header-icon"></i>
                  <span>用户历年新增情况</span>
                </div>
                <i class="threePoints el-icon-more"></i>
              </div>
              <div class="standards_content echartsHeight">
                <discountChart
                  :refId="'newUsersOverYearsChart'"
                  :datas="newUsersOverYears.dataList"
                  :transverseData="newUsersOverYears.transverseData"
                  :colorList="newUsersOverYears.colorList"
                  :legendList="newUsersOverYears.legendList"
                  :innerText="'单位：人'"
                ></discountChart>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第四层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问时间段分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userActivityChart'"
                :datas="userActivity.dataList"
                :transverseData="userActivity.transverseData"
                :colorList="userActivity.colorList"
                :legendList="userActivity.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源类型分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'resourceTypeChart'"
                :datas="resourceType.dataList"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第五层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问行为分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'behaviorDistributionChart'"
                :datas="behaviorDistribution.dataList"
                :transverseData="behaviorDistribution.transverseData"
                :colorList="behaviorDistribution.colorList"
                :legendList="behaviorDistribution.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>图形图像和文本类资源占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="textResources.dataList"
                :colorList="textResources.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第六层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源被课程引用占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'resourcesCitedChart'"
                :datas="resourcesCited.dataList"
                :colorName="'2'"
                :innerText="'数量'"
                :pieCenter="'43%'"
                :titleLeft="'26%'"
                :legendLeft="'53%'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>被课程引用资源情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'citedByCoursesChart'"
                :datas="citedByCourses.dataList"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>无访问资源占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'accessResourcesChart'"
                :datas="accessResources.dataList"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第七层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>原创资源占比</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="originalResources.dataList"
                :colorList="originalResources.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年资源访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'resourceAccessChart'"
                :datas="resourceAccess.dataList"
                :transverseData="resourceAccess.transverseData"
                :colorList="resourceAccess.colorList"
                :legendList="resourceAccess.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第八层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源历年新增情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'magnitudeChart'"
                :datas="yearResourceAdd.dataList"
                :transverseData="yearResourceAdd.transverseData"
                :colorList="colorList"
                :innerText="'单位：条'"
              ></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>本月资源访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'resourceAccessChart'"
                :datas="monthResourceVisit.dataList"
                :transverseData="monthResourceVisit.transverseData"
                :colorList="colorList"
                :gridWidth="true"
                :innerText="'单位：次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第八层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程与资源建设数量</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'magnitudeChart'"
                :datas="magnitude.dataList"
                :transverseData="magnitude.transverseData"
                :colorList="magnitude.colorList"
                :legendList="magnitude.legendList"
                :innerText="''"
              ></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程类型分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'courseTypeChart'"
                :datas="courseType.dataList"
                :colorName="'2'"
                :innerText="'数量'"
              ></circularChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程使用率</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="utilization.dataList"
                :colorList="utilization.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第九层 -->
      <!-- <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源访问行为分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'behaviorDistributeChart'" :datas='behaviorDistribute.dataList' :transverseData='behaviorDistribute.transverseData' :colorList='behaviorDistribute.colorList' :legendList='behaviorDistribute.legendList' :innerText="'单位：人次'"></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程性质分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'natureDistributionChart'" :datas='natureDistribution.dataList' :transverseData='natureDistribution.transverseData' :colorList='natureDistribution.colorList' :legendList="natureDistribution.legendList" :isShowBackground='true' :gridWidth='true' :innerText="'单位：门'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row> -->

      <!-- 第十层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>课程访问时间段分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'timeDistributionChart'"
                :datas="timeDistribution.dataList"
                :transverseData="timeDistribution.transverseData"
                :colorList="timeDistribution.colorList"
                :legendList="timeDistribution.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>题库题目使用率</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <meterChart
                :datas="questionBank.dataList"
                :colorList="questionBank.colorList"
              ></meterChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第十一层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年课程访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'interviewDistributionChart'"
                :datas="interviewDistribution.dataList"
                :transverseData="interviewDistribution.transverseData"
                :colorList="interviewDistribution.colorList"
                :legendList="interviewDistribution.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源内容年更新率</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart
                :refId="'participatingUnitsChart'"
                :datas="resourceYearUpdatePercents.dataList"
                :transverseData="resourceYearUpdatePercents.transverseData"
                :colorList="colorList"
                :legendList="resourceYearUpdatePercents.legendList"
                :innerText="'百分比：%'"
              />
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第十二层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="16">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>近一年资源库访问情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'libraryAccessChart'"
                :datas="libraryAccess.dataList"
                :transverseData="libraryAccess.transverseData"
                :colorList="libraryAccess.colorList"
                :legendList="libraryAccess.legendList"
                :gridWidth="true"
                :innerText="'单位：人次'"
              ></discountChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>标准化课程开课期数少于2期的课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits1.tableList"
                  :headerData="resourceVisits1.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits1.tableList.length >= 6"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(
                        52,
                        '标准化课程开课期数少于2期的课程(100名)',
                        resourceVisits1.headerList
                      )
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第十三层 -->
      <el-row :gutter="12" type="flex" style="margin-bottom: 10px">
        <el-col :span="16" ref="twelveFirst">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问较多的资源</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits2.tableList"
                  :headerData="resourceVisits2.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits2.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(43, '用户访问较多的资源（前100名）', resourceVisits2.headerList)
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16" ref="twelveSecond">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问较少的资源</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px 15px 0px 15px">
                <tableList
                  :tableData="resourceVisits3.tableList"
                  :headerData="resourceVisits3.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits3.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(42, '用户访问较少的资源（后100名）', resourceVisits3.headerList)
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第十四层 -->
      <el-row :gutter="12" type="flex">
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问较多的课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits4.tableList"
                  :headerData="resourceVisits4.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits4.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(45, '用户访问较多的课程（前100名）', resourceVisits4.headerList)
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>用户访问较少的课程</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding: 15px; padding-bottom: 0px">
                <tableList
                  :tableData="resourceVisits5.tableList"
                  :headerData="resourceVisits5.headerList"
                ></tableList>
                <div class="viewMore">
                  <el-button
                    v-if="resourceVisits5.tableList.length >= 10"
                    size="small"
                    class="upAndDown"
                    style="margin-left: 0px"
                    @click="
                      seeMore(44, '用户访问较少的课程（后100名）', resourceVisits5.headerList)
                    "
                    >查看更多</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog
      :title="detailsBox.title"
      :visible.sync="detailsBox.show"
      :close-on-click-modal="false"
      width="600px"
      class="pop_up distribute"
      append-to-body
      :before-close="handleClose"
    >
      <div class="moreBox">
        <tableList
          :tableData="detailsBox.data.tableList"
          :headerData="detailsBox.data.headerList"
        ></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>

<script>
import distributionChart from "@/components/chart/distributionChart.vue"; //地图
import circularChart from "@/components/chart/circularChart.vue"; //引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; //引入竖柱状图图表
import discountChart from "@/components/chart/discountChart.vue"; //引入折现图图表
import meterChart from "@/components/chart/meterChart.vue"; //仪表图
import tableList from "@/components/tableList.vue"; //表格

export default {
  components: {
    distributionChart,
    circularChart,
    vcolumnarChart,
    discountChart,
    meterChart,
    tableList,
  },
  data() {
    return {
      colorList: [
        "#1BF6F8",
        "#3B86FF",
        "#FA4798",
        "#6FE05F",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], //柱状图或折线图的颜色
      dashboardColor: [
        ["#E67070", "#E10303"],
        ["#ECB853", "#DF9C0D"],
        ["#43CCB3", "#12A888"],
      ], //仪表盘颜色红，黄，绿
      // 第一层
      // schools: {  // 参建学校分布
      //   dataList: [],
      // },
      // counted: {  // 其他建参单位数量(仅统计公司和协会)
      //   dataList: [],
      // },
      // units: {   //地图
      //   dataList: [],
      // },

      // 第一层
      // resourcesYears: {
      //   transverseData: [],
      //   dataList: [],
      //   colorList: [],
      //   legendList: []
      // },
      nowYear:"",//当前年
      nowMonth:"",//当前月
      userType: {
        //用户类型分布
        dataList: [],
      },
      participatingUnits: {
        //参建单位类型分布
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      realName: {
        //师生实名注册情况
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },

      // 第二层
      hostInstitutions: {
        //.主持院校实名教师占比情况
        dataList: 0,
        colorList: [],
      },
      takeCharge: {
        //主持院校实名学生占比情况
        dataList: 0,
        colorList: [],
      },
      educational: {
        //参建院校实名学生占比情况
        dataList: 0,
        colorList: [],
      },

      // 第三层
      proportionTeachers: {
        //实名教师无活动占比
        dataList: 0,
        colorList: [],
      },
      proportionStudents: {
        //实名学生无活动占比
        dataList: 0,
        colorList: [],
      },
      newUsersOverYears: {
        //用户历年新增情况
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },

      // 第四层
      userActivity: {
        //用户访问时间段分布
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      resourceType: {
        //资源类型分布
        dataList: [],
      },

      // 第五层
      behaviorDistribution: {
        //用户访问行为分布
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      textResources: {
        //文本型演示文稿、图形图像和文本类资源占比
        dataList: 0,
        colorList: [],
      },

      // 第六层
      resourcesCited: {
        //资源被课程引用占比
        dataList: [],
      },
      citedByCourses: {
        //被课程引用资源情况
        dataList: [],
      },
      accessResources: {
        //无访问资源占比
        dataList: [],
      },

      // 第七层
      originalResources: {
        //原创资源占比
        dataList: 0,
      },
      resourceAccess: {
        //近一年资源访问情况
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },

      // 第八层
      // 资源历年新增情况
      yearResourceAdd: {
        transverseData: [],
        dataList: [],
      },
      // 本月资源访问情况
      monthResourceVisit: {
        transverseData: [],
        dataList: [],
      },

      // 第八层
      magnitude: {
        //课程与资源建设数量
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      courseType: {
        //课程类型分布
        dataList: [],
      },
      utilization: {
        //课程使用率
        dataList: 0,
      },

      // // 第九层
      // behaviorDistribute: {    //资源访问行为分布
      //   transverseData: [],
      //   dataList: [],
      //   colorList: [],
      //   legendList: []
      // },
      // natureDistribution: {   //课程性质分布
      //   transverseData: [],
      //   dataList: [],
      //   colorList: [],
      //   legendList: []
      // },

      // 第十层
      timeDistribution: {
        //课程访问时间段分布
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      questionBank: {
        //题库题目使用率
        dataList: 0,
      },

      // 第十一层
      interviewDistribution: {
        //近一年课程访问情况
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      resourceContent: {
        //资源内容年更新率
        dataList: 0,
      },
      resourceYearUpdatePercents: {
        //近三年资源年更新率
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      // 第十二层
      libraryAccess: {
        //近一年资源库访问情况
        transverseData: [],
        dataList: [],
        colorList: [],
        legendList: [],
      },
      resourceVisits1: {
        //标准化课程开课期数少于2期的课程
        tableList: [],
        headerList: [],
      },

      //第十三层
      resourceVisits2: {
        //用户访问较多的资源
        tableList: [],
        headerList: [],
      },
      resourceVisits3: {
        //用户访问较少的资源
        tableList: [],
        headerList: [],
      },

      // 第十四层
      resourceVisits4: {
        //用户访问较多的课程
        tableList: [],
        headerList: [],
      },
      resourceVisits5: {
        //用户访问较少的课程
        tableList: [],
        headerList: [],
      },

      // 弹窗
      detailsBox: {
        title: "",
        show: false,
        data: {
          tableList: [],
          headerList: [],
        },
      },
    };
  },
  mounted() {
    // 第一层
    // this.schoolsDom()
    // this.countedDom()
    // this.unitsDom()

    // 获取当前年月
    this.getNowDate()

    // 第一层
    this.userTypeDom();
    this.participatingUnitsDom();
    this.realNameDom();

    // 第二层
    this.hostInstitutionsDom();
    this.takeChargeDom();
    this.educationalDom();

    // 第三层
    this.proportionTeachersDom();
    this.proportionStudentsDom();
    this.newUsersOverYearsDom();

    // 第四层
    this.userActivityDom();
    this.resourceTypeDom();

    // 第五层
    this.behaviorDistributionDom();
    this.textResourcesDom();

    // 第六层
    this.resourcesCitedDom();
    this.citedByCoursesDom();
    this.accessResourcesDom();

    // 第七层
    this.originalResourcesDom();
    this.resourceAccessDom();

    // 第八层
    this.getResourceOrUserUpdateVo();
    this.getMonthZykAdd();

    // 第八层
    this.magnitudeDom();
    this.courseTypeDom();
    this.utilizationDom();

    // 第九层
    // this.behaviorDistributeDom()
    // this.natureDistributionDom()

    // 第十层
    this.timeDistributionDom();
    this.questionBankDom();

    // 第十一层
    this.interviewDistributionDom();
    this.resourceContentDom();

    // 第十二层
    this.libraryAccessDom();
    this.resourceVisits1Dom();

    // 第十三层
    this.resourceVisits2Dom();
    this.resourceVisits3Dom();

    // 第十四层
    this.resourceVisits4Dom();
    this.resourceVisits5Dom();
  },
  methods: {
    // // 参建学校分布
    // schoolsDom() {
    //   this.$axios.post(this.$apiurls.overallPortrait_schools, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.schools.dataList = res.data
    //     }
    //   });
    // },
    // // 其他建参单位数量(仅统计公司和协会)
    // countedDom() {
    //   this.$axios.post(this.$apiurls.overallPortrait_counted, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.counted.dataList = res.data
    //     }
    //   });
    // },
    // // 参建单位覆盖区域
    // unitsDom() {
    //   this.$axios.post(this.$apiurls.overallPortrait_units, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.units.dataList = res.data
    //     }
    //   });
    // },
    // 获取当前年月
    getNowDate(){
      let date = new Date();
      this.nowYear = date.getFullYear();
      let month = date.getMonth() ;
this.nowMonth = (month > 9) ? month : ("0"+ month);
    },

    // 第一层
    // 用户类型分布
    userTypeDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getUserRegisterCount, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.userType.dataList = res.data;
          }
        });
    },
    // 参建单位类型分布
    participatingUnitsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCompanyAndAssociationSituation, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.participatingUnits.transverseData = res.data.transverseData;
            this.participatingUnits.dataList = res.data.dataList;
            this.participatingUnits.colorList = this.colorList;
            this.participatingUnits.legendList = res.data.legendList;
          }
        });
    },

    // 师生实名注册情况
    realNameDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getIsrealHasActiveSituation, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.realName.transverseData = res.data.transverseData;
            this.realName.dataList = res.data.dataList;
            console.log(this.realName.dataList, 1111111111111);
            this.realName.colorList = this.colorList;
            this.realName.legendList = res.data.legendList;
          }
        });
    },

    // 第二层
    // .主持院校实名教师占比情况
    hostInstitutionsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getRealNameTeachersInHostInstitution, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.hostInstitutions.dataList = value;
            if (value >= 90) {
              this.hostInstitutions.colorList = this.dashboardColor[2];
            } else {
              this.hostInstitutions.colorList = this.dashboardColor[0];
            }
          }
        });
    },
    // 主持院校实名学生占比情况
    takeChargeDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getRealNameStudentInHostInstitution, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.takeCharge.dataList = value;
            if (value >= 90) {
              this.takeCharge.colorList = this.dashboardColor[2];
            } else {
              this.takeCharge.colorList = this.dashboardColor[0];
            }
          }
        });
    },
    // 参建院校实名学生占比情况
    educationalDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getRealNameStudentsInParticipatingInstitutions, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.educational.dataList = value;
            if (value <= 90) {
              this.educational.colorList = this.dashboardColor[0];
            } else {
              this.educational.colorList = this.dashboardColor[2];
            }
          }
        });
    },

    // 第三层
    // 实名教师无活动占比
    proportionTeachersDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getProportionOfInactiveTeachers, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.proportionTeachers.dataList = value;
            if (value >= 10) {
              this.proportionTeachers.colorList = this.dashboardColor[0];
            } else if (value >= 8 && value < 10) {
              this.proportionTeachers.colorList = this.dashboardColor[1];
            } else {
              this.proportionTeachers.colorList = this.dashboardColor[2];
            }
          }
        });
    },
    // 实名学生无活动占比
    proportionStudentsDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getProportionOfInactiveStudents, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.proportionStudents.dataList = value;
            if (value >= 10) {
              this.proportionStudents.colorList = this.dashboardColor[0];
            } else if (value >= 8 && value < 10) {
              this.proportionStudents.colorList = this.dashboardColor[1];
            } else {
              this.proportionStudents.colorList = this.dashboardColor[2];
            }
          }
        });
    },
    // 用户历年新增情况
    newUsersOverYearsDom() {
      // this.newUsersOverYears.transverseData = [2019, 2020, 2021, 2022, 2023, 2024, 2025]
      // this.newUsersOverYears.dataList = [[100, 100, 41, 43, 894, 153, 1546], [132, 465, 13, 465, 165, 354, 147]]
      // this.newUsersOverYears.colorList = this.colorList
      // this.newUsersOverYears.legendList = ['测试1', '测试2']

      this.$axios
        .post(this.$apiurls.overallPortrait_getUserAddCountEveryYear, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.newUsersOverYears.transverseData = [];
            this.newUsersOverYears.dataList = [];
            this.newUsersOverYears.colorList = this.colorList;
            this.newUsersOverYears.legendList = [];

            this.newUsersOverYears.transverseData = res.data.transverseData;
            this.newUsersOverYears.dataList = res.data.dataList;
            this.newUsersOverYears.colorList = this.colorList;
            this.newUsersOverYears.legendList = res.data.legendList;
          }
        });
    },

    // 第四层
    // 用户访问时间段分布
    userActivityDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getUserActivityTrends, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.userActivity.transverseData = res.data.transverseData;
            this.userActivity.dataList = res.data.dataList;
            this.userActivity.colorList = this.colorList;
            this.userActivity.legendList = res.data.legendList;
          }
        });
    },
    // 资源类型分布
    resourceTypeDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceKindsStatisticsByTypeForPieEchart, 31, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.resourceType.dataList = res.data;
          }
        });
    },

    // 第五层
    // 用户访问行为分布
    behaviorDistributionDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getUserActionDistributionSituation, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var arrList = [];
            for (let i = 0; i < res.data.length; i++) {
              arrList.push(res.data[i].value);
            }
            this.behaviorDistribution.transverseData = res.data[0].name;
            this.behaviorDistribution.dataList = arrList;
            this.behaviorDistribution.colorList = this.colorList;
            this.behaviorDistribution.legendList = ["学生", "教师", "社会学习者", "企业用户"];
          }
        });
    },
    //文本型演示文稿、图形图像和文本类资源占比
    textResourcesDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getProportionOfTextResources, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.textResources.dataList = value;
            if (value > 50) {
              this.textResources.colorList = this.dashboardColor[0];
            } else if (value >= 40 && value <= 50) {
              this.textResources.colorList = this.dashboardColor[1];
            } else {
              this.textResources.colorList = this.dashboardColor[2];
            }
          }
        });
    },

    // 第六层
    // 资源被课程引用占比
    resourcesCitedDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getReferenceResourceSituation, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.resourcesCited.dataList = res.data;
          }
        });
    },
    // 被课程引用资源情况
    citedByCoursesDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceKindsStatisticsByTypeForPieEchart, 34, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.citedByCourses.dataList = res.data;
          }
        });
    },
    // 无访问资源占比
    accessResourcesDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceSumByType, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.accessResources.dataList = res.data;
          }
        });
    },

    // 第七层
    //   原创资源占比
    originalResourcesDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getOriginalResource, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.originalResources.dataList = value;
            if (value <= 80) {
              this.originalResources.colorList = this.dashboardColor[0];
            } else {
              this.originalResources.colorList = this.dashboardColor[2];
            }
          }
        });
    },
    // 近一年资源访问情况
    resourceAccessDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceCountByType, 30, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.resourceAccess.transverseData = res.data.transverseData;
            this.resourceAccess.dataList = res.data.dataList;
            this.resourceAccess.colorList = this.colorList;
            this.resourceAccess.legendList = res.data.legendList;
          }
        });
    },

    // 第八层
    // 资源历年新增情况
    getResourceOrUserUpdateVo() {
      this.$axios
        .post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo + "?statType=3", {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let data = res.data;
            let dataList = [];
            let transverseData = [];
            for (const item of data) {
              dataList.push(item.num);
              transverseData.push(item.yearUpdate.slice(0,4));
            }
            this.yearResourceAdd.dataList = dataList;
            this.yearResourceAdd.transverseData = transverseData;
          }
        });
    },
    // 本月资源访问情况
    getMonthZykAdd() {
      this.$axios
        .post(
          this.$apiurls.report_monthly_usersMonth,
          {
            type: 4,
            name: `${this.nowYear}-${this.nowMonth}`,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.monthResourceVisit.dataList = res.data.reourceAccess;
            let arr=[]
            for (let i = 0; i < res.data.reourceAccess.length; i++) {
              arr.push(i+1)
            }
            this.monthResourceVisit.transverseData = arr
          }
        });
    },
    // 第八层
    // 课程与资源建设数量
    magnitudeDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getNumberOfCoursesAndResources, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.magnitude.transverseData = res.data.transverseData;
            this.magnitude.dataList = res.data.dataList;
            this.magnitude.colorList = this.colorList;
            this.magnitude.legendList = res.data.legendList;
          }
        });
    },
    //课程类型分布
    courseTypeDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCourseCount, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseType.dataList = res.data;
          }
        });
    },
    // 课程使用率
    utilizationDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCourseUtilization, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.utilization.dataList = value;
            if (value < 100) {
              this.utilization.colorList = this.dashboardColor[0];
            } else {
              this.utilization.colorList = this.dashboardColor[2];
            }
          }
        });
    },

    // 第九层
    // // 资源访问行为分布
    // behaviorDistributeDom() {
    //   // this.$axios.post(this.$apiurls.overallPortrait_behaviors, 47, {
    //   //   loading: false,
    //   // }).then((res) => {
    //   //   if (res) {
    //   //     console.log("数据", res);
    //   //   }
    //   // });
    //   this.behaviorDistribute.transverseData = ['数据1', '数据2', '数据3']
    //   this.behaviorDistribute.dataList = [[50, 80, 10, 60], [80, 40, 30, 10], [500, 10, 70, 30]]
    //   this.behaviorDistribute.colorList = this.colorList
    //   this.behaviorDistribute.legendList = ['数据1', '数据2', '数据3']
    // },
    // // 课程性质分布
    // natureDistributionDom() {
    //   // this.$axios.post(this.$apiurls.overallPortrait_userYears, {
    //   //   loading: false,
    //   // }).then((res) => {
    //   //   if (res) {
    //   //     console.log("数据", res);
    //   //   }
    //   // });
    //   this.natureDistribution.transverseData = ['数据1', '数据2', '数据3', '1', '32', '3', '45', '345', '343', '3455', '677']
    //   this.natureDistribution.dataList = [50, 80, 10, 60, 45, 687, 45, 456645, 456, 456]
    //   this.natureDistribution.colorList = this.colorList
    //   this.natureDistribution.legendList = ['数据1']
    // },

    // 第十层
    // 课程访问时间段分布
    timeDistributionDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCourseActivityTrends, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.timeDistribution.transverseData = res.data.transverseData;
            this.timeDistribution.dataList = res.data.dataList;
            this.timeDistribution.colorList = this.colorList;
            this.timeDistribution.legendList = res.data.legendList;
          }
        });
    },
    // 题库题目使用率
    questionBankDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getUtilizationRateOfQuestionsInQuestionBank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            var value = res.data;
            this.questionBank.dataList = value;
            if (value <= 60) {
              this.questionBank.colorList = this.dashboardColor[0];
            } else {
              this.questionBank.colorList = this.dashboardColor[2];
            }
          }
        });
    },

    // 第十一层
    // 近一年课程访问情况
    interviewDistributionDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getCourseKindsStatisticsByTypeAndCourseType, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.interviewDistribution.transverseData = res.data.transverseData;
            this.interviewDistribution.dataList = res.data.dataList;
            this.interviewDistribution.colorList = this.colorList;
            this.interviewDistribution.legendList = res.data.legendList;
          }
        });
    },
    // 资源内容年更新率
    resourceContentDom() {
      this.$axios
        .post(this.$apiurls.resourceContentPercentForYear, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.resourceYearUpdatePercents.transverseData = res.data.transverseData;
            this.resourceYearUpdatePercents.dataList = res.data.dataList;
            this.resourceYearUpdatePercents.colorList = this.colorList;
            this.resourceYearUpdatePercents.legendList = res.data.legendList;
          }
        });
    },

    // 第十二层
    // 近一年资源库访问情况
    libraryAccessDom() {
      this.$axios
        .post(this.$apiurls.overallPortrait_getResourceLibraryAccessTrendChart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.libraryAccess.transverseData = res.data.transverseData;
            this.libraryAccess.dataList = res.data.dataList;
            this.libraryAccess.colorList = this.colorList;
            this.libraryAccess.legendList = res.data.legendList;
          }
        });
    },
    // 标准化课程开课期数少于2期的课程
    resourceVisits1Dom() {
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "7",
            statType: 52,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 7) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits1.tableList = res.data;
            this.resourceVisits1.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "课程名称",
                prop: "name",
              },
              {
                name: "创建者",
                prop: "author",
              },
              {
                name: "创建时间",
                prop: "createTime",
              },
            ];
          }
        });
    },

    // 第十三层表格
    // 用户访问较多的资源
    resourceVisits2Dom() {
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "11",
            statType: 18,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits2.tableList = res.data;
            this.resourceVisits2.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "资源名称",
                prop: "name",
              },
              {
                name: "上传者",
                prop: "author",
              },
              {
                name: "访问数",
                prop: "num",
              },
            ];
          }
        });
    },
    // 用户访问较少的资源
    resourceVisits3Dom() {
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "11",
            statType: 19,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits3.tableList = res.data;
            this.resourceVisits3.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "资源名称",
                prop: "name",
              },
              {
                name: "上传者",
                prop: "author",
              },
              {
                name: "上传时间",
                prop: "createTime",
              },
            ];
          }
        });
    },

    // 第十四层表格
    // 用户访问较多的课程
    resourceVisits4Dom() {
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "11",
            statType: 20,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits4.tableList = res.data;
            this.resourceVisits4.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "课程名称",
                prop: "name",
              },
              {
                name: "课程负责人",
                prop: "author",
              },
              {
                name: "访问数",
                prop: "num",
              },
            ];
          }
        });
    },
    // 用户访问较少的课程
    resourceVisits5Dom() {
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "11",
            statType: 21,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            if (res.data.length >= 11) {
              res.data.splice(res.data.length - 1, 1);
            }
            this.resourceVisits5.tableList = res.data;
            this.resourceVisits5.headerList = [
              {
                name: "序号",
                prop: "index",
              },
              {
                name: "课程名称",
                prop: "name",
              },
              {
                name: "课程负责人",
                prop: "author",
              },
              {
                name: "开课时间",
                prop: "createTime",
              },
            ];
          }
        });
    },

    // 查看更多
    seeMore(index, title, headerList) {
      this.$store.commit("isLoading", true);
      this.detailsBox.data.tableList = [];
      this.$axios
        .post(
          this.$apiurls.overallPortrait_getResourceVisitCountRankByType,
          {
            limitNum: "100",
            statType: index,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.$message({
              message: "查询成功！",
              type: "success",
            });
            this.detailsBox.data.tableList = res.data;
            this.detailsBox.data.headerList = headerList;
            this.detailsBox.show = true;
            this.detailsBox.title = title;
            this.$store.commit("modifyVague", true);
            this.$store.commit("isLoading", false);
          }
        })
        .catch((_) => {
          this.$store.commit("isLoading", false);
        });
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false;
      this.$store.commit("modifyVague", false);
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/table.scss" scoped></style>
<style lang="scss" scoped>
/* 第一层 */
.firstFloor {
  height: 796px;
  position: relative;
  margin-bottom: 12px;
}

.firstFloor .el-col-16 {
  height: 100%;
}

.record {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
/* 参建学校分布 */
.dataSources {
  position: relative;
  width: 100%;
  margin-bottom: 12px;
}

/* 其他建参单位数量 */
.picture {
  position: relative;
  width: 100%;
}

.firstFloor .echartsHeight {
  width: 100%;
  height: 352px;
}

/* 第二层 ,第三层 ,第四层,第五层,第六层,第七层,第八层,第九层,第十层 ,第十一层,第十二层,第十三层,第十四层 */
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
  margin: 0px auto;
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
</style>
